import { NavigationLink } from '../app/shared/interfaces/navigation-link';

// The top bar says why people shop; the department menu beside it says what things are. So no
// url here repeats one the department menu links, and each link is a page with its own title,
// H1 and description (Databases/Services/Catalogue/Collections.cs) and a place in the sitemap.
// Brands has no page of its own: it is a button that opens its menu (links.component.html), and
// each brand is its own url - brand names are what people search for. Gaming brands first, as
// in the department menu. Phones and tablets have no top bar: mobile-menu.ts opens with these
// same links, so keep the two in step.
export const navigation: NavigationLink[] = [
    {key: 'cat-new-arrivals', label: 'New Arrivals', url: '/products/latest'},
    {key: 'cat-deals', label: 'Deals', url: '/products/sale'},
    {key: 'cat-small-gifts', label: 'Small Gifts', url: '/products/under-20'},
    // The sellers' way in (PrimeCommerce_Seller_Content_Plan.md 4.4): /sell links on to PrimeCommerce.
    {key: 'sell', label: 'Sell', url: '/sell'},
];
